export const TABLE_HEAD = [
	{ id: "name", label: "Name", alignRight: false },
	{ id: "company", label: "Company", alignRight: false },
	{ id: "role", label: "Role", alignRight: false },
	{ id: "isVerified", label: "Verified", alignRight: false },
	{ id: "status", label: "Status", alignRight: false },
	{ id: "" },
];
